import { render, staticRenderFns } from "./PazienteTeleconsultiList.vue?vue&type=template&id=336245e6"
import script from "./PazienteTeleconsultiList.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports